import { connect } from 'react-redux';
import { getApiRoot } from '../reducer';
import ChangePassword from './ChangePassword';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    user = _ref.user;
  var userIdentity = _ref2.userIdentity;
  return {
    apiRoot: getApiRoot({
      application: application,
      user: user
    }),
    userIdentity: userIdentity
  };
};
export default connect(mapStateToProps)(ChangePassword);